var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"jdsc-input-area",class:_vm.classes,on:{"click":_vm.emitClick}},[_c('span',{staticClass:"jdsc-input-area__left"},[_vm._t("left")],2),_c('span',{staticClass:"jdsc-input-area__center"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }